import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import Footer from "../../component/Footer";
import ProductCardSkeleton from "../../component/ProductCardSkeleton";
import HeadingSkeleton from "../../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { NotificationManager } from "react-notifications";

// const fairbanner = require("./../assets/img/fair-banner.png");
// const logo = require("./../assets/img/puma-logo.png");
// const fairImg = require("./../assets/img/fair-listing.png");
// const wishImg = require("./../assets/img/wishlist-icon2.svg").default;

const FairTradeEvents = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { storeId } = useParams();

  const [openModal, setOpenModal] = useState();
  const [eventList, setEventList] = useState();
  const [loading, setLoading] = useState(true);

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/events`, {
        method: "POST",
        body: JSON.stringify({
          store_id: storeId,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.authorisation?.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setEventList(responseData.data.data);
      } else {
        NotificationManager.warning(responseData?.msg);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleAddStore = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // setResponseStatus(responseData?.msg);
          NotificationManager.success(responseData?.msg);
        } else {
          // setResponseStatus(responseData?.msg);
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  const handleRequestPrice = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/request-price`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          NotificationManager.success(responseData?.msg);
        } else {
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <div className="fullContainer">
      <div className="categoryDiv productSliderMain topNew tradePrdts">

        <div className="featureDiv productListMain">

          {loading ? (
            <HeadingSkeleton width="200px" height="28px" />
          ) : (
            <h2 className="storeTabHdn">{langJson?.events}</h2>
          )}

          <ul className="eventList products products-5-col">
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <ProductCardSkeleton key={index} />
              ))
            ) : eventList?.length > 0 ? (
              eventList?.map((item, index) => (
                <li key={index}>
                  <img src={IMAGE_URL + item?.image} alt="" />
                  <h3>{item?.title}</h3>
                  <p className="eventDate">{item?.formatted_start_date} - {item?.formatted_end_date}</p>
                  <p>{item?.location}</p>
                </li>
              ))
            ) : (
              <span className="noOrderDiv">{langJson?.norecordsfound}</span>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FairTradeEvents;
